module.exports = __webpack_public_path__ + "img/puzzle9_5.dbffcb29.jpg";